module.exports = __webpack_public_path__ + "static/media/illuminance.666f51a3.svg";